import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";
import SubCategory from "../SubCategory/SubCategory";
import { FaRegArrowAltCircleDown } from "react-icons/fa";
import { Config } from "../../Config";

const Category = (props) => {
  let mainCategory;
  let subCategory;
  const [category, setCategory] = useState([]);
  const user = useSelector((state) => state.user);

  useEffect(() => {
    axios
      .get(
        "Product/GetProductCategory",
        user[0]?.token && {
          headers: {
            Authorization: `Bearer ${user[0]?.token}`,
          },
        }
      )
      .then((result) => {
        setCategory(result.data.data);
        setActiveCategory();
      })
      .catch((error) => {
        console.log("error", error);
      });
  }, []);

  const setActiveCategory = () => {
    mainCategory = document.querySelectorAll(".mainCategory");
    subCategory = document.querySelectorAll(".subCategory");
    mainCategory[0]?.classList.add("active");
    subCategory[0]?.classList.add("active");
  };

  const openSubCategory = (e) => {
    mainCategory = document.querySelectorAll(".mainCategory");
    subCategory = document.querySelectorAll(".subCategory");
    for (let k = 0; k < mainCategory.length; k++) {
      mainCategory[k]?.classList.remove("active");
    }
    e.target.classList.add("active");
    let itemName = e.target.classList[1]; // change dynamic classlist[1] with gu-id
    for (let i = 0; i < subCategory.length; i++) {
      subCategory[i]?.classList.remove("active");
      if (itemName === subCategory[i].classList[1]) {
        subCategory[i]?.classList.add("active");
      }
    }
  };

  const showProduct = (id) => {
    props.history.replace({
      pathname: `/products`,
      state: { categoryId: id },
    });
  };

  const handleToggle = (ind) => {
    let targetAll = document.querySelectorAll(`.categoriesProduct`);
    let target = document.querySelector(`.categoriesProduct_${ind}`);
    let allTargetIcon = document.querySelectorAll(`.svgicon`);
    let targetIcon = document.querySelector(`.svgicon_${ind}`);
    if (target.classList.contains("activeTab")) {
      target.classList.remove("activeTab");
      targetIcon.classList.remove("activeIcon");
    } else {
      targetAll.forEach((i) => {
        i.classList.remove("activeTab");
      });
      allTargetIcon.forEach((i) => {
        i.classList.remove("activeIcon");
      });
      target.classList.add("activeTab");
      targetIcon.classList.add("activeIcon");
    }
    // if (target.classList.contains("activeTab")) {
    //   target.classList.remove("activeTab");
    //   targetIcon.classList.remove("activeIcon");
    // } else {
    //   target.classList.add("activeTab");
    //   targetIcon.classList.add("activeIcon");
    // }
  };
  return (
    <div className="menuItemSubMenu">
      <div className="rightSide">
        <div className="mainCategories">
          {category.map((item, index) => {
            return (
              // <span key={index} className={`sideMenuItem menuItem_${index + 1}`} onClick={() => showProduct(item.id)}>
              <span key={index} className={`sideMenuItem menuItem_${index + 1}`}>
                <div
                  className="titleWrapper"
                  onClick={() => {
                    handleToggle(index + 1);
                  }}
                >
                  <span className="title">{item.categoryName}</span>
                  <FaRegArrowAltCircleDown className={`svgicon svgicon_${index + 1}`} />
                </div>
                <div className={`categoriesProduct categoriesProduct_${index + 1}`}>
                  {item.categories?.map((i) => {
                    return (
                      <div
                        className="productItem"
                        onClick={() => {
                          showProduct(i.id);
                          props.closeSideMenu();
                        }}
                      >
                        <svg
                          stroke={Config.beforeColor}
                          fill={Config.beforeColor}
                          strokeWidth="0"
                          viewBox="0 0 256 512"
                          height="10px"
                          width="10px"
                          className="itemSvg"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"></path>
                        </svg>
                        {i.categoryName}
                      </div>
                    );
                  })}
                </div>
              </span>
            );
          })}
        </div>
      </div>
      {/* <div className="leftSide">
        <div className="subCategories">
          <SubCategory subCategory={category} />
        </div>
      </div> */}
    </div>
  );
};

export default React.memo(withRouter(Category));
